import {
  Billing,
  BalanceDetails,
  SingleBillingDetails,
  ProfessionalBillingDetails,
} from 'one-state-billing-details';



export const TransformBillingDetails = (response: any, context: any) => {

  let billingdata: Billing[] = [];
  let billingresult: any = {
      billingdata: billingdata,
      error: undefined

  }
  const { log,settings } = context;
  const {uisettings:{dateformat}} = settings
  log.debug("one-epic", "TransformBillingDetails transformation entered", response);
  if (response && (response.status >= 400 || response.type == "error")) {
      billingresult.error = response;
  }
  if (response && response.length > 0) {

      response.map((ele: any) => {

          if (ele) {
              let billing: Billing = {
                  serviceAreaName: "",
                  patientsGuarantor: false,
                  paperless: false,
                  AccountId: "",
                  AccountName: "",
                  balanceDetails: undefined,
                  singleBillingDetails: undefined,
                  professionalBillingDetails: undefined,
                  relation:""
              };

              let balancelist: BalanceDetails[] = [];
              let singlebillinglist: SingleBillingDetails[] = [];
              let professionalbillinglist: ProfessionalBillingDetails[] = [];
              billing.AccountId = ele.guarantorId ? ele.guarantorId : "";
              billing.AccountName = ele.guarantorName ? ele.guarantorName : "";
              billing.relation=ele.guarantorRelation?ele.guarantorRelation:"";
              let sboobj: BalanceDetails = {
                  type: "",
                  patientBalance: ele.amountDuePatientOrGuarantor !== null && ele.amountDuePatientOrGuarantor !== undefined ? `$${Number(ele.amountDuePatientOrGuarantor).toFixed(2)}` : "",
                  insuranceBalance: ele.amountDueInsurance !== null && ele.amountDueInsurance !== undefined ? `$${Number(ele.amountDueInsurance).toFixed(2)}` : ""
              }
              balancelist.push(sboobj);
              // let billlngtableinfo: SingleBillingDetails = {
              //     chargesdebt: ele.badDebtAmount !== null && ele.badDebtAmount !== undefined ? ele.badDebtAmount.toString() : "",
              //     totalcharges: ele.totalChargesToDate !== null && ele.totalChargesToDate !== undefined ? ele.totalChargesToDate.toString() : "",
              //     totalamountdue: ele.totalAmountDue !== null && ele.totalAmountDue !== undefined ? ele.totalAmountDue.toString() : "",
              //     totalpayrefund: ele.totalPaymentsRefundsAndAdjustmentToDate !== null && ele.totalPaymentsRefundsAndAdjustmentToDate !== undefined ? ele.totalPaymentsRefundsAndAdjustmentToDate.toString() : "",
              //     availablecredit: ele.availableCredit !== null && ele.availableCredit !== undefined ? ele.availableCredit.toString() : "",
              //     accountcredit: ele.accountCredit !== null && ele.accountCredit !== undefined ? ele.accountCredit.toString() : "",
              // };
              let billlngtableinfo: SingleBillingDetails = {
                  chargesdebt: ele.badDebtAmount !== null && ele.badDebtAmount !== undefined ? `$${ele.badDebtAmount.toFixed(2)}` : "",
                  totalcharges: ele.totalChargesToDate !== null && ele.totalChargesToDate !== undefined ? `$${ele.totalChargesToDate.toFixed(2)}` : "",
                  totalamountdue: ele.totalAmountDue !== null && ele.totalAmountDue !== undefined ? `$${ele.totalAmountDue.toFixed(2)}` : "",
                  totalpayrefund: ele.totalPaymentsRefundsAndAdjustmentToDate !== null && ele.totalPaymentsRefundsAndAdjustmentToDate !== undefined ? `$${ele.totalPaymentsRefundsAndAdjustmentToDate.toFixed(2)}` : "",
                  availablecredit: ele.availableCredit !== null && ele.availableCredit !== undefined ? `$${ele.availableCredit.toFixed(2)}` : "",
                  accountcredit: ele.accountCredit !== null && ele.accountCredit !== undefined ? `$${ele.accountCredit.toFixed(2)}` : ""
              };
              singlebillinglist.push(billlngtableinfo);
              billing.balanceDetails = balancelist;
              billing.singleBillingDetails = singlebillinglist;
              billing.professionalBillingDetails = professionalbillinglist;

              billingdata.push(billing);
          }
      });
  }
  billingresult.billingdata = billingdata;
  log.debug("one-epic", "TransformBillingDetails transformation Completed", billingresult);
  return billingresult;
}